"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _constants = require("../../constants");

const Radio = (0, _core.withStyles)(() => ({
  root: {
    color: _constants.colours.inactiveState,
    '&$checked': {
      color: _constants.colours.primary
    },
    '& .MuiSvgIcon-root': {
      width: '20px',
      height: '20px'
    }
  },
  checked: {
    '& .MuiSvgIcon-root:first-child': {
      color: _constants.colours.inactiveState
    }
  }
}))(_core.Radio);
var _default = Radio;
exports.default = _default;